import { createDriverNotificationTypes } from "dora-contracts";
import * as t from "io-ts";

export const {
  driverNotificationsT,
  driverNotificationT,
  driverNotificationTextT,
  driverNotificationRouteUpdatedT,
  driverNotificationStopDocumentsAddedT,
} = createDriverNotificationTypes({
  dateTime: t.string,
});

export type DriverNotification = t.TypeOf<typeof driverNotificationT>;
export type DriverNotificationText = t.TypeOf<typeof driverNotificationTextT>;
export type DriverNotificationRouteUpdated = t.TypeOf<typeof driverNotificationRouteUpdatedT>;
export type DriverNotificationStopDocumentsAdded = t.TypeOf<typeof driverNotificationStopDocumentsAddedT>;
